import { EXTRACTOR_USER_PREFIX } from '../constants';

export const isExtractorUser = (user: { email: string }) =>
    user.email.startsWith(EXTRACTOR_USER_PREFIX);
